// extracted by mini-css-extract-plugin
export var caption = "image-module--caption--8d64a";
export var container = "image-module--container--52415";
export var image = "image-module--image--4bebb";
export var imageContainer = "image-module--imageContainer--e7449";
export var optionalText = "image-module--optionalText--b6bb8";